import { Injectable } from '@angular/core';
import { ApiInterface, ApiService } from '../../../api/api.service';
import { FormModel } from '../models/form.model';

@Injectable()
export class EntityFormService extends ApiService implements ApiInterface {

    public restEndpoint = 'entities/{entityId}/forms';

    public model = FormModel;

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/form/services/entity-form.service.ts